// extracted by mini-css-extract-plugin
export default {"headerSpaceContainer":"style_headerSpaceContainer__OYnp9","mobileHeader":"style_mobileHeader__GZ0iX","deskHeader":"style_deskHeader__Mypp3"};